/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Slider from 'components/sliders/BaseSlider';

import { SCREEN_BREAKPOINTS } from 'utils/helpers/constants';

// eslint-disable-next-line import/no-cycle
import StyledContentBlock from '../StyledContentBlock';

import styles from './styles.module.scss';

const StyledContentTabs = ({ items }) => {
	const [activeTabIndex, setActiveTabIndex] = useState(0);

	const onClickTab = (event) => {
		const button = event.target;
		const currentIndexSlide = parseInt(button.dataset.index, 10);

		if (currentIndexSlide !== activeTabIndex) {
			setActiveTabIndex(currentIndexSlide);
		}

		button.blur();
	};

	return (
		<div className={styles.StyledContentTabs}>
			<div className={styles.StyledContentTabs_Tabs}>
				<Slider
					slideToNumber={activeTabIndex}
					theme="tabs"
					params={{
						spaceBetween: 8,
						breakpoints: {
							[SCREEN_BREAKPOINTS.mobileLarge]: {
								spaceBetween: 8
							},
							[SCREEN_BREAKPOINTS.tabletMedium]: {
								spaceBetween: 8
							},
							[SCREEN_BREAKPOINTS.tabletLarge]: {
								spaceBetween: 8
							}
						}
					}}
				>
					{items.map((item, index) => (
						<button
							type="button"
							className={cx(styles.StyledContentTabs_Button, {
								[styles.StyledContentTabs_Button__active]:
									activeTabIndex === index
							})}
							key={`tab-button-${item.title}-${index}`}
							data-index={index}
							onClick={onClickTab}
						>
							{item.title}
						</button>
					))}
				</Slider>
			</div>
			<div>
				{items[activeTabIndex].content.map((contentItem, index) => (
					<StyledContentBlock
						key={`${contentItem.type}-${index}`}
						type={contentItem.type}
						{...contentItem}
					/>
				))}
			</div>
		</div>
	);
};

StyledContentTabs.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string,
			title: PropTypes.string,
			content: PropTypes.arrayOf(
				PropTypes.shape({
					type: PropTypes.string
				})
			)
		})
	)
};

export default StyledContentTabs;
